import * as React from 'react';

interface IInfoBoxProps {
    boxType?: 'default' | 'warning' | 'highlight' | 'error' | 'success';
    children?: React.ReactNode;
}

const InfoBox: React.FunctionComponent<IInfoBoxProps> = props => {
    const { boxType, children } = props;

    let infoBoxClassNames: string = 'cell i-box';
    if (boxType !== 'default') {
        infoBoxClassNames += ` ${boxType}`
    }

    return (
        <div className="m-info">
            <div className={infoBoxClassNames}>
                {children}
            </div>
        </div>
    );
};

InfoBox.defaultProps = {
    boxType: 'default',
};

export default InfoBox;
